import { render } from "./ProjectSectionComponent.vue?vue&type=template&id=2cd3db3d&scoped=true"
import script from "./ProjectSectionComponent.vue?vue&type=script&lang=js"
export * from "./ProjectSectionComponent.vue?vue&type=script&lang=js"

import "./ProjectSectionComponent.vue?vue&type=style&index=0&id=2cd3db3d&lang=css"
import "./ProjectSectionComponent.vue?vue&type=style&index=1&id=2cd3db3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd3db3d"]])

export default __exports__